import { render, staticRenderFns } from "./IrisTextfieldCurrency.vue?vue&type=template&id=4dd22e6a&"
import script from "./IrisTextfieldCurrency.vue?vue&type=script&lang=ts&"
export * from "./IrisTextfieldCurrency.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports